import SlackBuilder from "./SlackBuilder";

export default SlackBuilder;
